import { createPendingAction } from '../../shared/storage/pendingAction';

/**
 * "This visitor was on their way to the hub."
 *
 * w-z.com links signed-in and signed-out visitors alike to /hub. A signed-out
 * one has to go through Auth0 first, and comes back to the dashboard with no
 * memory of where they were headed — so the intent is parked here across the
 * round trip and picked up once, on the first authenticated landing.
 */
const pending = createPendingAction('wz.pendingHubVisit');

export const rememberHubVisit = () => pending.remember('1');
export const clearHubVisit = pending.clear;

/** True once, then forgotten, so Back from the hub does not bounce them again. */
export function takeHubVisit(): boolean {
  const wanted = pending.read() !== null;
  if (wanted) pending.clear();
  return wanted;
}
